import React, { useEffect } from 'react'
import BarcodeReader from 'react-barcode-reader'

export default function BarcodeScanArea({ handleScanProduct }) {
    const handleScan = (data) => {
        if (data) {
            handleScanProduct(data);
        }
    }

    const handleScanError = () => {
        console.log("error scanning")
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Tab') {
                event.preventDefault();
            }
        };
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <BarcodeReader
            onError={handleScanError}
            onScan={handleScan}
            // timeBeforeScanTest={2}
            // endChar={[]}
            stopPropagation
            preventDefault
        // scanButtonLongPressThreshold={1}
        />
    )
}
